<template>
	<v-container>
      <v-layout>
          <v-flex xs12 sm10 md8 lg6>
               <v-card>
                   <v-alert
                    v-model="alertInput"
                    dismissible
                    type="error"
                  >
                    'Upps something is wrong! Please correct the mistakes'
                  </v-alert>
                <v-toolbar :color="cr.colorName" prominent>
                    <v-toolbar-title class="body-3 white--text">{{formTitle}}
                        <v-icon class="pl-2" color="white">{{iconTitle}}</v-icon>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
              <v-card-text>
                  <v-container>
                  <v-form ref='form'>
                    <v-layout row wrap>
                      <v-flex>
                        <v-select
                            v-bind:items="issue_type"
                            v-model="selected"
                            label="Issue Type"
                            input="selected"
                            class="input-group--focused"
                            item-value="text"
                            :hint= "selectHint"
                            persistent-hint
                            :error-messages="errors.collect('selected')"
                            v-validate="'required'"
                            required
                            data-vv-name="selected"
                            ></v-select>
                        </v-flex>
                      </v-layout>
                      <h4 class="mt-3 subheading font-weight-light">Select the issues you want to report</h4>
                      <v-layout row wrap>
                        <v-flex v-for="i in issueList" :key="i.issue" xs6>
                            <v-checkbox 
                              v-model="selectIssue"
                              :label="i.issue"
                              :value="i.issue"
                              v-validate="'required'"
                              name="issues"
                              :error-messages="errors.collect('issues')"
                              data-vv-name="issues">
                            </v-checkbox>
                        </v-flex>
                      </v-layout>
                       <v-layout row wrap>
                          <v-flex>
                            <v-textarea
                              label="Comments"
                              hint= "Comments about any issues"
                              persistent-hint
                              outline
                              v-model = "comments"
                              :error-messages="errors.collect('comments')"
                              v-validate="'max:500'"
                              data-vv-name="comments"
                              > 
                          </v-textarea>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                          <v-flex>
                              <v-text-field
                                label="Picture url"
                                v-model="picUrl"></v-text-field>
                          </v-flex>
                      </v-layout>
                      <v-layout row>
                          <v-flex>
                              <v-text-field
                                label="Ticket#"
                                v-model="ticket"></v-text-field>
                          </v-flex>
                      </v-layout>
                      <v-layout row class="mt-4">
                        <v-flex>
                          <v-btn class="white--text"  :color="cr.colorName" @click="submit()">Save <v-icon class="pl-1" color='white'>check_circle</v-icon></v-btn>
                          <v-btn  class="white--text" :color="cr.colorName" @click="cancel">Cancel<v-icon class="pl-1" color='white'>cancel</v-icon></v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
               </v-card>
          </v-flex>
      </v-layout>
    </v-container>
</template>
<script>
  import {bus} from '../../main'
  import {mapGetters} from 'vuex'
  export default {
    props: {
      issues: {
        type: Boolean
      },
      fromTasks: {},
      fromSearch: {
        type: Boolean
      },
      fromInstaller: {
        type: Boolean
      },
      editForm: {
        type: Boolean
      },
      editIssueData: {
        type: Object
      },
      editFromSearch: {
        type: Array
      },
      cr: {
        type: Object
      },
      displayId: {},
      code: {
        type: String
      }
    },
    data () {
      return {
        alertInput: false,
        formTitle: 'Add Issues',
        iconTitle: 'add_circle',
        picUrl: '',
        ticket: '',
        comments: '',
        menuIssuedDate: false,
        menuResolvedDate: false,
        dateIssued: new Date().toISOString(),
        selected: '',
        warning_msg: 'You are about to update multiple entries. Make sure you know the correct job number!!',
        selectIssue: [],
        issue_type: ['Content', 'Display'],
        issueList: [
          {issue: 'Broken lock-top'},
          {issue: 'Broken lock-bottom'},
          {issue: 'Damage number decal'},
          {issue: 'Prongs damage/broken'},
          {issue: 'Base not bolted down'},
          {issue: 'Glass broken'},
          {issue: 'Grafitti'},
          {issue: 'Diffuser'},
          {issue: 'Could Not Access'},
          {issue: 'Missing'},
          {issue: 'Poster Failling'},
          {issue: 'Etching on Film'},
          {issue: 'Etching on Metal'},
          {issue: 'Aesthetic'},
          {issue: 'Wrong PSA'},
          {issue: 'Other'}],
        selectHint: 'Content or Display case issue',
        openCloseForms: {
          add: false,
          edit: false,
          task: false,
          search: false,
          searchEdit: false,
          installer: false
        }
      }
    },
    computed: {
      ...mapGetters({currentUser: 'currentUser'})
    },
    watch: {
      editFromSearch () {
        this.formTitle = 'Edit Issues'
        this.iconTitle = 'edit'
        this.selected = this.editFromSearch[0].issue_type
        this.comments = this.editFromSearch[0].comments
        this.ticket = this.editFromSearch[0].ticket
        this.picUrl = this.editFromSearch[0].picture_url
        this.dateIssued = this.editFromSearch[0].issue_date
        this.dateResolved = this.editFromSearch[0].resolved_date
        this.selectIssue = [...this.editFromSearch[0].issue.data]
        this.openCloseForms.searchEdit = true
      },
      fromSearch () {
        this.openCloseForms.search = true
        this.$validator.reset()
      },
      fromTasks () {
        console.log('hello')
        this.openCloseForms.task = true
        this.$validator.reset()
      },
      issues () {
        this.openCloseForms.add = true
        this.$refs.form.reset()
        this.$validator.reset()
      },
      fromInstaller () {
        this.openCloseForms.installer = true
        this.$validator.reset()
      },
      editIssueData () {
        this.formTitle = 'Edit Issues'
        this.iconTitle = 'edit'
        this.selected = this.editIssueData.issue_type
        this.comments = this.editIssueData.comments
        this.ticket = this.editIssueData.ticket
        this.picUrl = this.editIssueData.picture_url
        this.dateIssued = this.editIssueData.issue_date
        this.dateResolved = this.editIssueData.resolved_date
        this.selectIssue = [...this.editIssueData.issue.data]
        this.openCloseForms.edit = true
        this.$validator.reset()
      }
    },
    methods: {
      submit () {
        this.$validator.validateAll().then((results) => {
          if (results) {
            this.save()
          } else {
            this.alertInput = true
          }
        })
      },
      save () {
        var vm = this
        if (this.openCloseForms.searchEdit) {
          var payloadSearchEdit = {
            id: this.editFromSearch[0].id,
            displayFk: this.editFromSearch[0].displayFk,
            code: this.code,
            issue_type: this.selected,
            issue: {data: this.selectIssue},
            comments: this.comments,
            picture_url: this.picUrl,
            ticket: this.ticket,
            issue_date: this.dateIssued,
            resolved_date: this.dateResolved
          }
          this.$http.post('/mapsdata/issues/edit', payloadSearchEdit)
            .then(function (response) {
              vm.$validator.reset()
              vm.$refs.form.reset()
              vm.$store.dispatch('closeForm')
              bus.$emit('saveSearchEdit', true)
            })
        }
        if (this.openCloseForms.search) {
          var payloadSearch = {
            data: {
              displayFk: this.displayId,
              code: this.code,
              issue_type: this.selected,
              issue: {data: this.selectIssue},
              comments: this.comments,
              picture_url: this.picUrl,
              ticket: this.ticket,
              issue_date: this.dateIssued,
              resolved_date: this.dateResolved
            },
            fromTask: this.fromTask,
            fromSearch: this.fromSearch
          }
          this.$http.post('/mapsdata/issues/add', payloadSearch)
            .then(function (response) {
              vm.$validator.reset()
              vm.$refs.form.reset()
              vm.$store.dispatch('closeForm')
              bus.$emit('saveSearchEdit', true)
            })
        }
        if (this.openCloseForms.task || this.openCloseForms.installer) {
          var payloadTask = {
            data: {
              displayFk: this.displayId,
              code: this.code,
              issue_type: this.selected,
              issue: {data: this.selectIssue},
              comments: this.comments,
              picture_url: this.picUrl,
              ticket: this.ticket,
              issue_date: this.dateIssued,
              resolved_date: this.dateResolved === undefined ? null : this.dateResolved
            },
            fromTask: this.fromTask,
            fromSearch: this.fromSearch,
            fromInstaller: this.fromInstaller
          }
          this.$http.post('/mapsdata/issues/add', payloadTask)
            .then(function (response) {
              vm.$validator.reset()
              vm.$refs.form.reset()
              bus.$emit('closeFormIssuesTask', {close: false, code: vm.code})
              bus.$emit('saveForm', true)
            })
        }
        if (this.openCloseForms.add) {
          var payload = {
            data: {
              displayFk: this.displayId,
              code: this.code,
              issue_type: this.selected,
              issue: {data: this.selectIssue},
              comments: this.comments,
              picture_url: this.picUrl,
              ticket: this.ticket,
              issue_date: this.dateIssued,
              resolved_date: this.dateResolved
            },
            fromTask: this.fromTask
          }
          this.$http.post('/mapsdata/issues/add', payload)
            .then(function (response) {
              vm.$refs.form.reset()
              bus.$emit('closeFormIssues', false)
              bus.$emit('saveForm', true)
            })
        }
        if (this.openCloseForms.edit) {
          var payloadEdit = {
            id: this.editIssueData.id,
            displayFk: this.displayId,
            code: this.code,
            issue_type: this.selected,
            issue: {data: this.selectIssue},
            comments: this.comments,
            picture_url: this.picUrl,
            ticket: this.ticket,
            issue_date: this.dateIssued,
            resolved_date: this.dateResolved
          }
          this.$http.post('/mapsdata/issues/edit', payloadEdit)
            .then(function (response) {
              bus.$emit('closeFormEditIssues', false)
              bus.$emit('saveForm', true)
            })
        }
      },
      resetValues () {
        this.selected = ''
        this.selectIssue = ''
        this.comments = ''
        this.ticket = ''
        this.picUrl = ''
        this.dateIssued = null
        this.dateResolved = null
      },
      cancel () {
        if (this.openCloseForms.searchEdit) { // edits an issue from search component
          this.$validator.reset()
          this.$store.dispatch('closeForm')
        }
        if (this.openCloseForms.search) { // adds a new issue from search component
          this.$validator.reset()
          this.$store.dispatch('closeForm')
        }
        if (this.openCloseForms.task) {
          this.$validator.reset()
          this.$refs.form.reset()
          bus.$emit('closeFormIssuesTask', false)
        }
        if (this.openCloseForms.edit) {
          this.$validator.reset()
          bus.$emit('closeFormEditIssues', false)
        }
        if (this.openCloseForms.add) {
          this.$validator.reset()
          this.$refs.form.reset()
          bus.$emit('closeFormIssues', false)
        }
        if (this.openCloseForms.installer) {
          this.$validator.reset()
          this.$refs.form.reset()
          bus.$emit('closeFormIssuesInstaller', false)
        }
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Forms/Issues.vue